import { handleJsonResponse, requestPost, SERVICE_URL } from 'util/request';

import { DispatchFilter } from './types';

export const requestDispatchPlans = async (page: number, filter: DispatchFilter) =>
  handleJsonResponse(
    await requestPost(`${SERVICE_URL}/dispatch_filtered_plans/`, {
      body: {
        page,
        ...filter,
      },
    }),
  );
